import { isAnon } from '@anm/auth/helpers/authAnon';
import { toObject } from '@anm/helpers/parseParams';
import { isAnonUser } from '@anm/helpers/user/isUser';
import { ComponentType } from 'react';
import { compose, lifecycle } from 'recompose';
import { User } from 'user';

import withPosition, { PositionProps, PositionState } from '../../../../../HOCs/withPosition';
import withUser, { WithUserProps } from '../../../../../HOCs/withUser';

export const SOCIAL_EMAIL_VIEW = 0;
export const EMAIL_AUTH_VIEW = 1;
export const UPDATE_USER_VIEW = 2;

type HOCs = WithUserProps & PositionProps;

const renderUpdateUserFormIfNoEmail = (userProfile: User | null, { current, next }: PositionState) => {
  if (!userProfile || userProfile.email || isAnon() || isAnonUser(userProfile) || current === UPDATE_USER_VIEW) return;
  next(UPDATE_USER_VIEW);
};

const renderEmailFormIfEmailProvided = ({ current, next }: PositionState) => {
  const { email } = toObject<{ email?: string }>(location.search);
  if (!email || current === EMAIL_AUTH_VIEW) return;
  next(EMAIL_AUTH_VIEW);
};

function componentDidUpdate(this: { props: HOCs }) {
  const {
    user: { profile },
    position
  } = this.props;

  renderUpdateUserFormIfNoEmail(profile, position);
  renderEmailFormIfEmailProvided(position);
}

export default <P extends HOCs>(BaseComponent: ComponentType<P & HOCs>) =>
  compose<HOCs & P, P>(withUser, withPosition(), lifecycle<HOCs, {}>({ componentDidUpdate }))(BaseComponent);
